import cx from 'classnames';

import { HEADING_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import styles from './Heading.css';

const renderer = ({ node: { type, data }, HEADING_TAG, ...attributes }) => {
  if (type === HEADING_DEFINITIONS.type) {
    const H = HEADING_TAG || `h${data.level}`;
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return (
      <H {...restOfAttributes} data-editor-plugin={H}>
        {children}
      </H>
    );
  }
};

const headingRenderer = (props) => {
  const {
    node: { data: { level } = {} },
    className,
  } = props;

  const headingClassName = cx(
    styles.heading,
    styles[`heading${level}`],
    className
  );

  return renderer({
    ...props,
    className: headingClassName,
  });
};

export { headingRenderer };
